import React, { useCallback, useMemo, useState } from 'react';

import { AuthTags } from '~constants/authTags';

import { ClickableIcon, ContainerHeader, TabContainer } from '~components';
import { faCog, faMoneyBill } from '~components/icon';

import { CoContributions } from './index';
import CoContributionSettingsModal from './CoContributionSettingsModal';

const CoContributionsContainer: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openSettings = useCallback(() => setIsOpen(true), []);
  const tabs = useMemo(() => [{ id: 'sah-co-contributions', title: 'Co-Contributions', component: CoContributions }], []);

  return (
    <div className="p-2">
      <ContainerHeader icon={faMoneyBill} iconSize="1x" className="info" dataCy="sah-co-contributions-header">
        <div className="d-flex align-items-center gap-1">
          <span>Support at Home - Client Co-Contributions</span>
          <ClickableIcon
            icon={faCog}
            id="co-contribution-settings-button"
            toolTip="Edit Co-Contribution Settings"
            onClick={openSettings}
            authTag={AuthTags.SUPPORTATHOME.SUPPLIERINVOICES.SETTINGS}
            dataCy="co-contribution-settings-icon"
          />
        </div>
      </ContainerHeader>
      <TabContainer tabs={tabs} />
      <CoContributionSettingsModal setIsOpen={setIsOpen} isOpen={isOpen} />
    </div>
  );
};

export default CoContributionsContainer;
